export const CrmSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://navatel.ir/#organization",
      "name": "نواتل",
      "legalName": "نواتل",
      "url": "https://navatel.ir/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://navatel.ir/wp-content/uploads/logo.png"
      },
      "description": "تنها سرویس ارتباطات یکپارچه ابری با اپلیکیشن اختصاصی و بدون محدودیت در ایران؛ ارائه‌دهنده مرکز تلفن ابری، CRM ابری، خط تلفن اینترنتی، پنل پیامکی و فکس آنلاین.",
      "sameAs": [
        "https://www.linkedin.com/company/mynavatel",
        "https://www.instagram.com/navatel.ir",
        "https://www.threads.com/@navatel.ir"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+98-21-82800000",
        "areaServed": "IR",
        "availableLanguage": ["fa"]
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://navatel.ir/#website",
      "url": "https://navatel.ir/",
      "name": "نواتل",
      "publisher": {
        "@id": "https://navatel.ir/#organization"
      },
      "inLanguage": "fa-IR"
    },
    {
      "@type": "WebPage",
      "@id": "https://navatel.ir/products/crm/#webpage",
      "url": "https://navatel.ir/products/crm/",
      "name": "خرید CRM ابری | مدیریت ارتباط با مشتری به‌صورت آنلاین",
      "description": "سیستم مدیریت ارتباط با مشتری (CRM) ابری نواتل با یکپارچگی کامل با مرکز تلفن و پنل پیامکی؛ کلیک‌تو‌کال، پاپ‌آپ تماس و ارسال پیامک از پروفایل مشتری، بدون نیاز به API.",
      "isPartOf": {
        "@id": "https://navatel.ir/#website"
      },
      "about": {
        "@id": "https://navatel.ir/products/crm/#service"
      },
      "inLanguage": "fa-IR",
      "breadcrumb": {
        "@id": "https://navatel.ir/products/crm/#breadcrumb"
      }
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://navatel.ir/products/crm/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "خانه",
          "item": "https://navatel.ir/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "محصولات",
          "item": "https://navatel.ir/products/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "CRM ابری",
          "item": "https://navatel.ir/products/crm/"
        }
      ]
    },
    {
      "@type": "Service",
      "@id": "https://navatel.ir/products/crm/#service",
      "name": "CRM ابری نواتل",
      "alternateName": "نرم‌افزار مدیریت ارتباط با مشتری نواتل",
      "serviceType": "نرم‌افزار مدیریت ارتباط با مشتری تحت ابر (Cloud CRM)",
      "description": "CRM ابری نواتل ابزاری برای مدیریت یکپارچه ارتباط با مشتریان است که با مرکز تلفن ابری و پنل پیامکی نواتل کاملاً یکپارچه شده؛ بدون نیاز به سرور، نصب یا تیم IT و بدون نیاز به پیاده‌سازی API. تاریخچه تعاملات، اطلاعات مشتری و سوابق تماس/پیامک در یک پروفایل واحد با دید ۳۶۰ درجه در دسترس است.",
      "provider": {
        "@id": "https://navatel.ir/#organization"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Iran"
      },
      "audience": {
        "@type": "BusinessAudience",
        "audienceType": "کسب‌وکارها و سازمان‌ها (B2B)"
      },
      "url": "https://navatel.ir/products/crm/",
      "brand": {
        "@id": "https://navatel.ir/#organization"
      },
      "additionalProperty": {
        "@type": "PropertyValue",
        "name": "دوره پرداخت اشتراک",
        "value": "پرداخت سالانه، به ازای هر کاربر در ماه"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "پلن‌های اشتراک CRM ابری نواتل",
        "itemListElement": [
          {
            "@type": "AggregateOffer",
            "name": "بسته پایه CRM ابری نواتل",
            "description": "شروع ارتباطات کسب‌وکار؛ شامل پنل مدیریتی پیشرفته، اپلیکیشن تخصصی، مدیریت مشتریان، سرنخ‌های فروش، مدیریت فرصت‌های فروش، وظایف و پیگیری‌ها، مدیریت محصولات و انبار و صدور فاکتور و پیش‌فاکتور. قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
            "url": "https://navatel.ir/products/crm/",
            "priceCurrency": "IRR",
            "lowPrice": "1190000",
            "highPrice": "3840000",
            "offerCount": "2",
            "eligibleQuantity": {
              "@type": "QuantitativeValue",
              "minValue": 1,
              "maxValue": 300,
              "unitText": "کاربر"
            }
          },
          {
            "@type": "AggregateOffer",
            "name": "بسته عملیاتی CRM ابری نواتل",
            "description": "مرکز تماس حرفه‌ای؛ شامل همه ویژگی‌های بسته پایه به‌علاوه مدیریت دپارتمان و اعضای تیم، مدیریت نقش سطوح و حقوق، تیکتینگ، گزارش‌گیری پیشرفته تیکت‌ها، قابلیت اتصال به مرکز تلفن ابری نواتل، کلیک‌تو‌کال و پاپ‌آپ تماس. قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
            "url": "https://navatel.ir/products/crm/",
            "priceCurrency": "IRR",
            "lowPrice": "1250000",
            "highPrice": "4180000",
            "offerCount": "2",
            "eligibleQuantity": {
              "@type": "QuantitativeValue",
              "minValue": 1,
              "maxValue": 300,
              "unitText": "کاربر"
            }
          },
          {
            "@type": "AggregateOffer",
            "name": "بسته یکپارچه CRM ابری نواتل",
            "description": "محبوب‌ترین بسته؛ همه کانال‌های ارتباطی در یک بستر. شامل همه ویژگی‌های بسته عملیاتی به‌علاوه تاریخچه تعاملات و پروفایل ۳۶۰ درجه، اتوماسیون گردش‌کار، پنل پیامکی با خط اختصاصی، وب‌سرویس پنل پیامکی، چت آنلاین یکپارچه، اتصال به واتساپ و یکپارچه‌سازی کانال‌های ارتباطی. قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
            "url": "https://navatel.ir/products/crm/",
            "priceCurrency": "IRR",
            "lowPrice": "1650000",
            "highPrice": "5440000",
            "offerCount": "2",
            "eligibleQuantity": {
              "@type": "QuantitativeValue",
              "minValue": 1,
              "maxValue": 300,
              "unitText": "کاربر"
            }
          },
          {
            "@type": "AggregateOffer",
            "name": "بسته فراگیر CRM ابری نواتل",
            "description": "کامل‌ترین راهکار ارتباط با مشتری؛ شامل همه ویژگی‌های بسته یکپارچه به‌علاوه کلیه قابلیت‌های مرکز تماس، تلفن گویای چندسطحی، صف تماس با استراتژی‌های مختلف، مانیتورینگ زنده کاربران، نجوا و ورود و کنترل به مکالمات، گزارش‌های پیشرفته تماس و اتصال به آی‌پی‌فون. قیمت به ازای هر کاربر در ماه، پرداخت سالانه.",
            "url": "https://navatel.ir/products/crm/",
            "priceCurrency": "IRR",
            "lowPrice": "2690000",
            "highPrice": "8570000",
            "offerCount": "2",
            "eligibleQuantity": {
              "@type": "QuantitativeValue",
              "minValue": 1,
              "maxValue": 300,
              "unitText": "کاربر"
            }
          }
        ]
      }
    }
  ]
}